export default "__VITE_ASSET__BNNm6iXy__"